import { render } from "./SettingsLanguages.vue?vue&type=template&id=0b9ed9bf&ts=true"
import script from "./SettingsLanguages.vue?vue&type=script&lang=ts"
export * from "./SettingsLanguages.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__